import { render, staticRenderFns } from "./ParticipantPin.vue?vue&type=template&id=470a598e&scoped=true&"
import script from "./ParticipantPin.vue?vue&type=script&lang=js&"
export * from "./ParticipantPin.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantPin.vue?vue&type=style&index=0&id=470a598e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a598e",
  null
  
)

export default component.exports